import { useCallback, useMemo, useState } from 'react';
import { cx, css } from '@linaria/core';
import { useFormikContext } from 'formik';
import { Concept } from 'api/grpc/resources';
import { useModalActions } from 'components/ModalManager/Context';
import { Button } from 'components/ui_library/Button';
import { noop } from 'utils/fp';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { formContainer, inputContainer } from 'modules/Models/components/ModelForm/styles';
import { FormLabel } from '../FormLabel';
import { SelectModalConcept, ConceptDetails } from './SelectModalConcept';
import { tagsSectionCls } from '../ConceptFormElement/Concepts/ConceptSelector/styles';
import { ConceptTags } from '../ConceptFormElement/Concepts/ConceptSelector/ConceptTags';
export const SelectConceptsButton = ({
  path
}: {
  path: string;
}) => {
  const {
    openModal,
    closeModal
  } = useModalActions();
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const {
    fieldValueMap
  } = (values as FormikInitialValues);
  const {
    description
  } = selectModelTypeFieldTypeInfo(path, (values as FormikInitialValues));
  const [selectedConcepts, setSelectedConcepts] = useState<Concept[]>([]);
  const conceptMap = useMemo(() => selectedConcepts.reduce((acc, item: Concept) => {
    acc[item.getName()] = item.getValue();
    return acc;
  }, ({} as Record<string, number>)), [selectedConcepts]);
  const setConcepts = (concepts: ConceptDetails[]) => {
    let filteredSelectedConcepts: Concept[] = [];
    const formattedConcepts = concepts.map((concept: ConceptDetails) => {
      filteredSelectedConcepts = selectedConcepts.filter(c => c.getId() !== concept.id);
      const newConcept = new Concept();
      newConcept.setName(concept.name);
      newConcept.setId(concept.id);
      if (concept.value) newConcept.setValue(concept.value);
      return newConcept;
    });
    const allSelectedConcepts = [...filteredSelectedConcepts, ...formattedConcepts];
    const cleanedValues = allSelectedConcepts.length ? allSelectedConcepts.map(concept => ({
      id: concept.getId(),
      name: concept.getName(),
      value: concept.getValue()
    })) : [];
    setFieldValue('fieldValueMap', {
      ...fieldValueMap,
      [path]: cleanedValues
    });
    setSelectedConcepts(allSelectedConcepts);
  };
  const clickHandler = () => {
    const modalId = 'SELECT-CONCEPTS-MODAL';
    openModal({
      id: modalId,
      title: 'Select concept',
      content: <SelectModalConcept modalId={modalId} fieldValue={conceptMap} closeModal={closeModal} setFieldValue={setConcepts} />,
      makeActions: noop
    });
  };
  const handleConceptRemoved = useCallback((concept: Concept) => {
    setSelectedConcepts(selectedConcepts.filter(c => c.getId() !== concept.getId()));
  }, [selectedConcepts]);
  return <div className={formContainer}>
      <div className={inputContainer}>
        <FormLabel path={path} description={(description as string)} />
        <div className={conceptContainer}>
          <div className="select-concept-button">
            <Button variant="primary" onClick={clickHandler}>
              Select Concepts
            </Button>
          </div>
          <div className={cx(tagsSectionCls)}>
            {selectedConcepts.map(concept => <ConceptTags key={concept.getId()} concept={concept} onRemoveTag={() => handleConceptRemoved(concept)} />)}
          </div>
        </div>
      </div>
    </div>;
};
const conceptContainer = "odules__Models__components__ModelForm__components__FormComponentRenderer__FormComponents__SelectConceptModal__SelectConceptsButton_tsx-conceptContainer-cyco1k";

require("./SelectConceptsButton.linaria.module.css!=!../../../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./SelectConceptsButton.tsx");